const bs = {
    product_identification: 'Jedinstvena identifikacijska oznaka vrste proizvoda:',
    manufacturer: 'Proizvođač i ovlašteni zastupnik',
    product_type: 'Vrsta proizvoda',
    core_type: 'Vrsta izolacije:',
    application: 'Područje primjene',
    system: 'Sistem/sistemi ocjenjivanja i provjere stalnosti svojstava:\n',
    harmonized_standard:'Usklađeni standard:',
    notified_body:'Obavještajno tijelo/tijela:',
    technical_document:'Dokument o europskom tehničkom ocjenjivanju:',
    fire_and_resistance:'II) Reakcija na vatru:',
    fire_reaction: 'Reacija na vatru',
    declaration: 'Izjava o svojstvima',
    face_back_material: 'Materijal, lice /naličje',
// MAIN SECTIONS
    basic_information: 'Opće informacije',
    fire_resistance: 'Reakcija i otpornost na vatru',
    material: 'Materijal',
    characteristics: 'Ključne karakteristike',
// TABLE HEADERS
    characteristic: 'Osnovne karakteristike',
    value: 'Vrijednost',
    standard: 'Dokument / Standard',
// CHARACTERISTICS
    u_value:
        'VI) Koef. prenosa toplote U-vrijednost',
    lambda:
        'VII) Koef. toplotne provodljivosti jezgre',
    mechanical_resistance:
        'VIII) Mehanička otpornost',

    zatezna_cvrstoca:
        'a) Zatezna čvrstoća',
    modul_zatezanja:
        'b) Modul zatezanja',
    zatezna_temp:
        'c) Zatezna čvrstoća pri povišenoj temperaturi',
    modul_temp:
        'd) Modul zatezanja pri povišenoj temperaturi',
    pritisna:
        'e) Pritisna čvrstoća',
    modul_pritiska:
        'f) Modul pritiska',
    smicanje:
        'g) Čvrstoća smicanja',
    smicanje_dugotrajno:
        'h) Redukovana dugotrajna čvrstoća smicanja',
    modul_smicanja:
        'i) Modul smicanja',
    puzanje_2000:
        'j) Koeficijent puzanja t=2.000h',
    puzanje_100000:
        'k) Koeficijent puzanja t=100.000h',
    l_group:
        'l) Kap. momenta savijanja slobodno oslonjenog panela',
    l_pozitivno:
        'Pozitivno',
    l_pozitivno_temp:
        'Pozitivno, povišena temperatura',
    l_negativno:
        'Negativno',
    l_negativno_temp:
        'Negativno, povišena temperatura',

    m_group:
        'm) Odnos između momenta savijanja i reakcije oslonaca',
    m_kapacitet:
        'Kapacitet momenta savijanja',
    m_pozitivno:
        'Pozitivno',
    m_pozitivno_temp:
        'Pozitivno, povišena temperatura',
    m_negativno:
        'Negativno',
    m_negativno_temp:
        'Negativno, povišena temperatura',
    n_group:
        'n) Napon boranja - gornji lim',
    n_u_polju:
        'U polju',
    n_u_polju_temp:
        'U polju, povišena temperatura',
    n_srednji_oslonac:
        'Na srednjem osloncu',
    n_srednji_oslonac_temp:
        'Na srednjem osloncu, povišena temperatura',
    o_group:
        'o) Napon boranja - donji lim',
    o_u_polju:
        'U polju',
    o_srednji_oslonac:
        'Na srednjem osloncu',
    ix_pozar:
        'IX) Izloženosti vanjskom požaru',
    x_voda:
        'X) Vodena propustljivost',

    xi_zrak:
        'XI) Zračna propustljivost',
    xii_para:
        'XII) Propustljivost vodene pare',
    xiii_zvuk:
        'XIII) Zvučna izolacija u zraku',
    xiv_apsorpcija:
        'XIV) Apsorpcija zvuka',
    xv_trajnost:
        'XV) Trajnost',
    xvi_test:
        'XVI) Test klina',
    dokumentacija:
        '8. Odgovarajuća tehnička dokumentacija i/ili specifična tehnička',

    signed_for: 'Za proizvođača i u njegovo ime potpisao:',
    footer_declaration: 'Svojstva proizvoda utvrđena iznad su u skladu sa setom objavljenih svojstava. Ova izjava o svojstvima objavljena je u skladu sa uredbom o građevinskim proizvodima broj 305/2011 pod isključivom odgovornošću proizvođača identificiranog iznad.' + '\n\n' +

        '1 Atestna dokumentacija otpornosti na vatru se izdaje na zahtjev kupca ' + '\n' +
        '2 Kapaciteti momenta savijanja su dati za debljinu lima 0,4/0,4)'  + '\n' +
        '3 U skladu sa EN-14509, EN-13165 i korištenim materijalima, ova karakteristika je potvrđena bez testiranja'  + '\n',

    npd_translation:
        'nije deklarisano svojstvo',
    thickness: 'Debljina',
    general_manager: 'General Manager',

    // =========================
    // EN 13165
    // =========================

    toplotna_otpornost:
        'Toplotna otpornost',

    toplotna_provodljivost:
        'Toplotna provodljivost',

    tolerancije_debljine_group:
        'V) Tolerancije debljine',

    kategorija_tolerancije:
        'Kategorija tolerancije',

    plus_tolerancija:
        'Plusna tolerancija [+mm]',

    minus_tolerancija:
        'Minusna tolerancija [-mm]',

    reakcija_na_vatru_group:
        'VI) Reakcija na vatru',

    performance_class:
        'Klasa performansi',

    smoke_classification:
        'Klasifikacija razvoja dima',

    flaming_droplets:
        'Klasifikacija zapaljivih kapljica',

    izdrzljivost_group:
        'VIII) Izdržljivost',

    dimenzionalna_stabilnost:
        'Dimenzionalna stabilnost',

    deformacija_pod_opterecenjem:
        'Deformacija pod opterećenjem',

    cvrstoca_na_pritisak:
        'IX) Čvrstoća na pritisak (CS(10/Y)100, NPD)',

    cvrstoca_na_zatezanje:
        'X) Čvrstoća na zatezanje',

    vodopropusnost_group:
        'XII) Vodopropusnost',

    kratkotrajna_apsorpcija_vode:
        'Kratkotrajna apsorpcija vode',

    dugotrajna_djelimicna_apsorpcija:
        'Dugotrajna djelimična apsorpcija',

    dugotrajna_potpuna_apsorpcija:
        'Dugotrajna potpuna apsorpcija',

    ravnost_nakon_kvasenja:
        'Ravnost nakon kvašenja',

    paropropusnost:
        'XIII) Paropropusnost',

    indeks_apsorpcije_zvuka:
        'XIV) Indeks apsorpcije zvuka',

    ispustanje_opasnih_materija:
        'XV) Ispuštanje opasnih materija',

    kontinuirano_uzareno_izgaranje:
        'XVI) Kontinuirano užareno izgaranje',

    application_14509_wall:
        'Metalom obložen termoizolacioni panel za upotrebu u građevinarstvu - Zidovi i oblaganje zidova',

    application_14509_roof:
        'Metalom obložen termoizolacioni panel za upotrebu u građevinarstvu - Krovovi i oblaganje krovova',

    application_14509_coldroom:
        'Metalom obložen termoizolacioni panel za upotrebu u građevinarstvu - Hladionički panel',

    application_13165:
        'Termoizolacione ploče za upotrebu u građevinarstvu - Izolacija podova, zidova, krovova',

    laminirana_folija:
        'Laminirana folija',
}
export default bs